import { DataTable } from '@cartwheel/components'
import React from 'react'
import { formatDate } from '../lib/date-utils'
import type { Appointment } from './appointment-row'

export interface SurveyResponsesRowProps {
  appointment: Appointment
}

export function SurveyResponsesRow({ appointment }: SurveyResponsesRowProps) {
  if (appointment.external_survey_responses.length === 0) return null

  return (
    <DataTable.Row className="!bg-gray-50">
      <DataTable.Cell colSpan={5} className="!py-2 px-6 text-sm">
        <span className="inline-flex items-center gap-2">
          <span className="font-medium">Survey:</span>
          {appointment.external_survey_responses.map((survey, idx) => (
            <React.Fragment key={survey.id}>
              <span className="inline-flex items-center gap-1">
                {survey.submitted_at ? (
                  <>
                    <i className="fa-solid fa-check text-forest" />
                    {survey.url ? (
                      <a
                        href={survey.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-forest underline hover:text-forest-dark"
                      >
                        {formatDate(survey.submitted_at)}
                      </a>
                    ) : (
                      <span className="text-forest">
                        {formatDate(survey.submitted_at)}{' '}
                        <span className="text-charcoal-50">(No URL)</span>
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-clock text-gold" />
                    {survey.url ? (
                      <a
                        href={survey.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gold underline hover:text-gold-dark"
                      >
                        Pending
                      </a>
                    ) : (
                      <span className="text-gold">Pending (No URL)</span>
                    )}
                  </>
                )}
              </span>
              {idx < appointment.external_survey_responses.length - 1 && ', '}
            </React.Fragment>
          ))}
        </span>
      </DataTable.Cell>
    </DataTable.Row>
  )
}
